import React from 'react'
import Background from '../Components/Background'
import workinprogres from '../assets/image/workinprogress.gif'
const Profile = () => {
  return (
    <div className="w-screen h-screen" >
             

        <div className='z-40 text-teal-50 flex relative justify-center w-full h-full items-center'>
            <div className='flex flex-col justify-center items-center'>
                 <img src={workinprogres} className="w-[80%] " alt='work in progress'/>
                 <div className='animate-pulse flex flex-row justify-center items-center newfont text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text font-extrabold'>we are working......</div>
                </div>
          
        </div> <Background/>
    </div>
  )
}

export default Profile
